import { Box, Divider, Grid, makeStyles } from '@material-ui/core';
import React from 'react'
import ViewProcedureSection from './ViewProcedureSection';
import ViewCriticalParameters from './ViewCriticalParameter';

const useStyles = makeStyles((theme) => ({
    root: {
      height: "auto",
      // padding: theme.spacing(2),
      boxSizing: "border-box",
    },
    section: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      // overflowY: "auto",
      // maxHeight: "100%", // Max height to allow scrolling
      // borderLeft: "1px solid #ccc", // Divider between sections
    },
      divider: {
          height: 'auto',
          alignSelf: 'stretch', // Ensures the divider fills the available height
        },
  //   scrollableSection: {
  //     overflowY: "auto",
  //     maxHeight: "calc(100vh - 50px)", // Adjust based on fixed elements like headers
  //   },
}));

const data={
    collabrixQCSamplingID:23,
    procedureNumber:2334,
    qcSamplingStatus: 'completed',
  qcSamplingID: 1,
  qcSamplingName: 'REACTION SAMPLE',
  criticalQualityAttributes:[
    { parameter: 'Product Concentration', upperLimit: 750, lowerLimit: 500, value: 600, uom: 'g/L' },
    { parameter: 'Product Amount', upperLimit: 750, lowerLimit: 650, value: 700, uom: 'KG' },
    { parameter: 'Impurity 1 Concentration', upperLimit: 200, lowerLimit: 60, value: 50, uom: 'mg/L' },
  ]
  }
  

const SamplesComponent = (props) => {
  const classes = useStyles();
  const { data } = props;
    const sample = true;
  return (
    <Grid container className={classes.root}>
      {/* Section 1 */}
      <Grid item xs={sample ? 2: 4}>
        <Box className={`${classes.section}`} style={{paddingLeft:'0px'}}>
        <ViewProcedureSection data={data} sample={sample} />
        </Box>
      </Grid>

      <Divider orientation="vertical" flexItem className={classes.divider} />
      {/* Section 2 */}
      <Grid item xs={sample ? 9: 7}>
      <Box className={`${classes.section}`}>
      <ViewCriticalParameters parameters={sample ? data.criticalQualityAttributes :data.criticalProcessParameters} sample={sample} />
        </Box>
          </Grid>
          </Grid>
  )
}

export default SamplesComponent